import { RouterStore } from 'mobx-react-router'

export default new RouterStore()
